import React, { useEffect, useState } from 'react';
import { get, useFormContext } from 'react-hook-form';

import { SCCalendar } from '../components';
import { useToast } from '../context/ToastContext';
import api from '../services/api';
import { useAuth } from '../providers/auth';

interface Props {
    showDelete: boolean;
    aluno?: any;
    setDatas: (datas: { Parcela: number, Data: Date | null }[]) => void;
}

const AlunosFormVencimentoNegociado: React.FC<Props> = ({ showDelete, setDatas, aluno }) => {
    const toast = useToast();
    const { periodoSelecionado } = useAuth();

    const [parcelas, setParcelas] = useState<any>();

    const { control, formState: { errors }, getValues, setValue, watch } = useFormContext();

    const watchPlanoPagamento = watch('AlunosPeriodo.PlanoPagamentoId')

    useEffect(() => {
        load()
    }, [watchPlanoPagamento])

    const load = async () => {
        if (watchPlanoPagamento) {
            const parcelas = await api.get('/planosPagamento/parcelas', {
                params: {
                    PlanosPagamentoId: watchPlanoPagamento
                }
            })
            setParcelas(parcelas.data || null)

            if (aluno.AlunoId) {
                const mensalidades = await api.get('/mensalidades/listMensalidadesAluno', {
                    params: {
                        Matricula: aluno.Matricula,
                        EmpresaId: periodoSelecionado?.EmpresaId,
                        Ano: periodoSelecionado?.Ano,
                        Sequencial: periodoSelecionado?.Sequencial,
                    }
                })
                if (mensalidades.data && Array.isArray(mensalidades.data)) {
                    mensalidades.data.forEach((item: any) => {
                        if (item.Parcela && item.DataVencimentoNegociado) {
                            const [year, month, day] = item.DataVencimentoNegociado.split('T')[0].split('-');
                            const date = new Date(Number(year), Number(month) - 1, Number(day));
                            setValue(`DataVencimentoNegociado_${item.Parcela}`, date);
                        }
                    });
                }
            }
        }
    }

    useEffect(() => {
        if (!parcelas || parcelas.length === 0) return;

        const campos = parcelas.map((p: any) => `DataVencimentoNegociado_${p.Parcela}`);

        const subscription = watch((values, { name }) => {
            if (name && campos.includes(name)) {
                const datas = parcelas.map((item: any) => ({
                    Parcela: item.Parcela,
                    Data: values[`DataVencimentoNegociado_${item.Parcela}`] || null,
                }));
                setDatas(datas);
                // console.log(datas)
            }
        });

        return () => subscription.unsubscribe();
    }, [parcelas, watch]);


    return (
        <div className='grid' >
            {parcelas ? parcelas.map((item: any) => (
                <div key={item.Parcela} className='col-4 grid align-items-center mb-3'>
                    <div className='col-4' style={{ fontSize: '13px' }}>{item.Parcela} {item.Descricao}</div>
                    <div className='col-6'>
                        <SCCalendar
                            control={control}
                            name={`DataVencimentoNegociado_${item.Parcela}`} // campo único para cada parcela
                            dateFormat="dd/mm/yy"
                            mask="99/99/9999"
                            className="w-full"
                        />
                    </div>
                </div>
            )) : ''}
        </div>
    );
};

export default AlunosFormVencimentoNegociado;
